import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Grid } from "../core/components/grid.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { CheckBox } from "../core/components/checkBox.js";
import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../core/components/commonApp.js";
import { General } from "../../siteManagement/general.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { InstalledInfo } from "./installedInfo.js";
import { FieldInstance } from "../core/components/field.js";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { GraphChannel, GraphTeam } from "./innobot.js";
import { Filter } from "./filter.js";
import { KeyValuePair } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";

interface TeamsInfoProps {
    defaultLocation: string;
    localizations: KeyValuePair<string, string>[];
}

interface TeamsInfoState {
    function: "startsWith" | "endsWith";
    filter: string;
    data: GraphTeam[];
}

export class TeamsInfo extends React.Component<TeamsInfoProps, TeamsInfoState>{
    private openTeamBtnId = "openTeam";
    private metaData: Metadata;
    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "displayName",
                title: Helper.getTranslation("MST.UI.Team"),
                template: (dataItem: GraphTeam) => {
                    return dataItem.displayName;
                }
            }
            //{
            //    field: "visibility",
            //    title: "Visibility***",
            //    template: (dataItem: GraphTeam) => {
            //        return dataItem.visibility;
            //    }
            //}
        ]
    };
    private groups: Group[];

    constructor(props) {
        super(props)
        this.state = {
            filter: "",
            function: "startsWith",
            data: []
        }
        this.initApp();
    }

    private initApp = async () => {
        const fields = ([
            {
                visible: true,
                componentName: "renderDisplayInfo()",
                model: "",
                type: "dynamic",
                name: "",
                labelAndControlCombined: true
            },
            {
                visible: true,
                componentName: "renderInstalledInfo()",
                model: "",
                type: "dynamic",
                name: "",
                labelAndControlCombined: true
            }
        ]);
        this.metaData = {
            menuDataSource: [
                //{
                //    type: "save"
                //},
                {
                    text: Helper.getTranslation("MST.UI.Install"),
                    onClick: "installApp()",
                    icon: "check",
                    show: "showInstallationButton"
                }
            ],
            additional: {
                objects: []
            },
            tabs: [
                {
                    title: "",
                    guid: kendo.guid(),
                    regions: [
                        {
                            title: Helper.getTranslation("Server.Allgemein"),
                            renderHeader: true,
                            fields: fields,
                            size: [
                                {
                                    container: "extrasmall",
                                    width: "12/12"
                                },
                                {
                                    container: "small",
                                    width: "12/12"
                                },
                                {
                                    container: "medium",
                                    width: "4/12"
                                },
                                {
                                    container: "large",
                                    width: "4/12"
                                },
                                {
                                    container: "extralarge",
                                    width: "4/12"
                                }
                            ]
                        }, {
                            title: Helper.getTranslation("MST.UI.GroupChannelMapping"),
                            renderHeader: true,
                            visible: "!showInstallationButton",
                            size: [
                                {
                                    container: "extrasmall",
                                    width: "12/12"
                                },
                                {
                                    container: "small",
                                    width: "12/12"
                                },
                                {
                                    container: "medium",
                                    width: "6/12"
                                },
                                {
                                    container: "large",
                                    width: "6/12"
                                },
                                {
                                    container: "extralarge",
                                    width: "6/12"
                                }
                            ],
                            fields: [{
                                visible: true,
                                componentName: "renderMappings()",
                                model: "",
                                type: "dynamic",
                                name: "",
                                labelAndControlCombined: true
                            } as any]
                        }
                    ]
                }
            ],
        };
        const [groups] = await Promise.all([
            HTTPService.get<Group[]>("ResourceLookup/GetAllGroups"),
        ]);
        this.groups = groups;
        this.setState({})
    }


    private loadChannels = async (teamId: string) => {
        const result = await HTTPService.get(`InnoBot/GetChannels?teamId=${teamId}`);
        return result;
    }


    private openTeam = async (_, team: GraphTeam) => {
        const channels = await this.loadChannels(team.id);
        const entity: TeamsEntity = {
            channels: channels,
            description: team.description,
            displayName: team.displayName,
            id: team.id,
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            IndividualFields: {},
        }
        const props: TeamsInfoSheetProps = {
            defaultLocation: this.props.defaultLocation,
            context: {},
            dataSources: {
                groups: this.groups,
                localizations: this.props.localizations
            },
            entity: entity,
            isWindow: false,
            metadata: this.metaData,
            title: team.displayName,
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(TeamsInfoSheet, props);
        });
    }


    private loadTeams = async (filter: string) => {
        const result = await HTTPService.get<GraphTeam[]>(`InnoBot/GetTeams?filter=${filter}`);
        if (!Array.isArray(result)) {
            NotificationHelper.showErrorMessage("Un unexpected error has occured")
        } else {
            this.setState({ data: result })
        }
    }

    private renderGrid = () => {
        if (this.state.data.length == 0)
            return null;
        const buttons: GridCustomToolBarButton[] = [
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Standard.Öffnen"), enabled: true, iconClass: "fa-light fa-eye", id: this.openTeamBtnId }
        ];
        const data = this.state.data.sort((a, b) => {
            if (a.displayName < b.displayName)
                return -1
            if (a.displayName > b.displayName)
                return 1
            return 0;
        });
        return (
            <div className="flex-container" style={{ height: "300px" }} >
                <Grid
                    data={data}
                    options={this.gridOptions}
                    id="teamsInfo"
                    customButtons={buttons}
                    onClickCustomButton={this.openTeam}
                />
            </div>
        )
    }

    render() {
        return (
            <>
                <Filter onTrigger={this.loadTeams} properties={[{ Key: "displayName", Value: "DisplayName***" }]} />
                {this.renderGrid()}
            </>

        );
    }
}

class TeamsInfoSheet extends React.Component<TeamsInfoSheetProps, any>{
    private infoRef: InstalledInfo;
    common = new AppHelper();
    showInstallationButton: boolean = false;

    constructor(props) {
        super(props)
        this.showInstallationButton = false;
        this.common.enableHooks = true;
        this.common.init(this);
    }

    private afterCheck = (isInstalled: string) => {
        this.showInstallationButton = !isInstalled;
        this.setState({});
    }

    private handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    installApp = async () => {
        const url = `InnoBot/InstallAtTeam?teamId=${this.props.entity.id}`;
        const result = await HTTPService.get<JsonResultClass>(url);
        if (result.Code == 0)
            this.infoRef.recheck();
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    renderDisplayInfo = () => {
        return (
            <div style={{ display: "flex", flexDirection: "column" }} >
              {/*  <label style={{ margin: "2px", fontSize: "21px" }} >{this.props.entity.displayName}</label>*/}
                {Helper.isNullOrEmpty(this.props.entity.description) || this.props.entity.description == this.props.entity.displayName ? null : <label style={{ margin: "2px" }}>{this.props.entity.description}</label>}
            </div>
        );
    }

    renderInstalledInfo = () => {
        return <InstalledInfo checkUrl={`InnoBot/IsInstalledForTeam?teamId=${this.props.entity.id}`} afterCheck={this.afterCheck} ref={(ref) => { this.infoRef = ref }} />
    }

    renderMappings = () => {
        return <MappingsGrid teamId={this.props.entity.id} channels={this.props.entity.channels} groups={this.props.dataSources.groups} localizations={this.props.dataSources.localizations} defaultLocation={this.props.defaultLocation} />
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.entity.displayName)
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface Group {
    GrNr: number;
    Bezeichnung: string;
}


interface TeamsInfoSheetProps extends AppBaseProps {
    entity: TeamsEntity;
    defaultLocation: string;
}

interface TeamsEntity extends Entity, GraphTeam{
    channels: GraphChannel[];
};

interface MappingsGridProps {
    teamId: string;
    groups: Group[];
    channels: GraphChannel[];
    localizations: KeyValuePair<string, string>[];
    defaultLocation: string;
}

interface MappingsGridState {
    mappings: GroupChannelMapping[]
}

class MappingsGrid extends React.Component<MappingsGridProps, MappingsGridState>{

    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "GrNr",
                title: Helper.getTranslation("Einsatz.GrNrFilter"),
                template: (dataItem: GroupChannelMapping) => {
                    if (Helper.hasValue(this.props.groups)) {
                        const group = this.props.groups.find(f => f.GrNr == dataItem.GrNr)
                        return Helper.hasValue(group) ? group.Bezeichnung : dataItem.GrNr;
                    }
                    return "";
                }
            },
            {
                field: "ChannelId",
                title: Helper.getTranslation("MST.UI.Channel"),
                template: (dataItem: GroupChannelMapping) => {
                    const channel = this.props.channels.find(f => f.id == dataItem.ChannelId)
                    return Helper.hasValue(channel) ? channel.displayName : dataItem.ChannelId;

                }
            },
            {
                field: "Locale",
                title: Helper.getTranslation("MST.UI.Locale"),
                template: (dataItem: GroupChannelMapping) => {
                    return dataItem.Locale
                }
            },
            {
                field: "IsActive",
                title: Helper.getTranslation("Adresse.Freigegeben"),
                template: (dataItem: GroupChannelMapping) => {
                    if (dataItem.IsActive) {
                        return "<div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div>";
                    } else {
                        return "<div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div>"
                    }
                }
            }
        ]
    };


    constructor(props) {
        super(props)
        this.state = {
            mappings: []
        };
        this.initApp();
    }

    private initApp = async () => {
        const [result] = await Promise.all([
            HTTPService.get(`InnoBot/GetGroupChannelMappings?teamId=${this.props.teamId}`)
        ]);
        let mappings = result.Data;
        if (!Helper.hasValue(mappings))
            mappings = [];
        this.setState({ mappings: mappings })
    }

    private sortGridData = (a: GroupChannelMapping, b: GroupChannelMapping) => {
        const a_group = this.props.groups.find(g => g.GrNr == a.GrNr);
        const b_group = this.props.groups.find(g => g.GrNr == b.GrNr);

        if (a_group < b_group) {
            return -1;
        }

        if (a_group > b_group) {
            return 1;
        }


        const a_channel = this.props.channels.find(c => c.id == a.ChannelId).displayName;
        const b_channel = this.props.channels.find(c => c.id == b.ChannelId).displayName;

        if (a_channel < b_channel) {
            return -1;
        }

        if (a_channel > b_channel) {
            return 1;
        }

        return 0;
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: GroupChannelMapping) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const newItem: GroupChannelMapping = {
                    Id: kendo.guid(),
                    IsActive: true,
                    Locale: this.props.defaultLocation,
                    GrNr: this.props.groups[0].GrNr,
                    TeamId: this.props.teamId,
                    ChannelId: null//this.props.teams[0].channels[0].id
                };
                this.edit(newItem, true);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.edit(dataItem, false);
                break;
            case ToolBarStandardButtonType.DELETE:
                this.deleteMapping(dataItem)
                break;
        }
    }

    private edit = (dataItem: GroupChannelMapping, isNew: boolean) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);

        const destroy = () => {
            root.unmount();
            targetElement[0].remove();
        }

        const onOk = async (mapping: GroupChannelMapping) => {
            const isOk = await this.saveMapping(mapping)
            if (!isOk)
                return;
            const data = this.state.mappings;
            const index = this.state.mappings.findIndex(map => map.Id == mapping.Id)
            if (index > -1) {
                data[index] = mapping
            } else {
                data.push(mapping);
            }
            this.setState({mappings: data})
            destroy();
        }

        const validate = (mapping: GroupChannelMapping) => {
            const isNew = !Helper.hasValue(this.state.mappings.find(map => map.Id == mapping.Id))
            if (!isNew)
                return true;

            let con = !Helper.hasValue(this.state.mappings.find(map => map.ChannelId == mapping.ChannelId))
            if (!con) {
                NotificationHelper.showWarningMessage('Dieser Kanal wird bereits verwendet***')
                return false;
            }
            con = !Helper.hasValue(this.state.mappings.find(map => map.GrNr == mapping.GrNr));
            if (!con) {
                NotificationHelper.showWarningMessage('Diese Gruppe wird bereits verwendet****')
                return false;
            }

            return true;
        }

        root.render(
            <>
                <MappingDialog
                    groups={this.props.groups}
                    mapping={dataItem}
                    onCancel={destroy}
                    onOk={onOk}
                    validate={validate}
                    localizations={this.props.localizations}
                    title={isNew ? Helper.getTranslation("MST.UI.NewMapping") : Helper.getTranslation("MST.UI.EditMapping")}
                    isNew={isNew}

                />
            </>
        );
    }

    private saveMapping = async (mapping: GroupChannelMapping) => {
        const result = await HTTPService.post<JsonResultClass>("InnoBot/SaveGroupChannelMapping", { mapping: mapping });
        if (result.Code != 0) {
            NotificationHelper.showErrorMessage(result.Message);
        }
        return result.Code == 0;
    }

    private deleteMapping = async (mapping: GroupChannelMapping) => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOk)
            return;
        const result = await HTTPService.get<JsonResultClass>(`InnoBot/DeleteGroupChannelMapping?id=${mapping.Id}`);
        if (result.Code != 0) {
            NotificationHelper.showErrorMessage(result.Message);
        } else {
            const mappings = this.state.mappings.filter(f => f.Id != mapping.Id);
            this.setState({ mappings: mappings })
        }

    }

    render() {
        const buttons: ToolBarStandardButton[] = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("WebSMS.Reminder.Edit"), enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true },
        ];
        let mappings = this.state.mappings;
        if (!Helper.hasValue(mappings)) {
            mappings = []
        }
        return (
            <div className="flex-container">
                <Grid
                    data={mappings.sort(this.sortGridData)}
                    options={this.gridOptions}
                    id="groupChannel"
                    standardButtons={buttons}
                    onClickStandardButton={this.onButtonClick}
                />

            </div>
        );
    }
}

interface GroupChannelMapping {
    ChannelId: string;
    GrNr: number;
    Id: string;
    IsActive: boolean;
    Locale: string;
    TeamId: string;
}

class MappingDialog extends React.Component<MappingDialogProps, { mapping: GroupChannelMapping, channels: GraphChannel[] }> {
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: "",
        actions: [
            {
                action: this.props.onCancel,
                label: Helper.getTranslation("Standard.Abbrechen"),
                primary: false,
            },
            {
                action: () => {

                    this.onOk();
                    return false;
                },
                label: Helper.getTranslation("Standard.OK"),
                primary: true,
            }
        ],
        open: true,
        width: 500
    };
    private button: HTMLElement;

    constructor(props: MappingDialogProps) {
        super(props)

        this.state = {
            mapping: props.mapping,
            channels: []
        }
        this.dialogProps.title = props.title;
        this.initApp();
    }

    private initApp = async () => {
        const channels = await this.loadChannels(this.state.mapping.TeamId);
        this.setState({ channels: channels })
    }

    private loadChannels = async (teamId: string) => {
        const result = await HTTPService.get(`InnoBot/GetChannels?teamId=${teamId}`);
        return result;
    }

    private onOk = async () => {
        const isValid = this.props.validate(this.state.mapping);
        if (isValid) {
            this.props.onOk(this.state.mapping)
        }
    }

    private buildDropDown = (translationKey: string, field, dataSource: KeyValuePair<any, string>[], disabled: boolean) => {
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = disabled;
        props.value = this.state.mapping[field];
        props.dataSource = dataSource;
        props.field.dataValueField = "Key";
        props.field.dataTextField = "Value";
        props.field.refreshDSOnRefChange = true;
        props.field.optionLabel = "";
        props.onChange = async (_, value) => {
            if (Helper.isNullOrEmpty(value))
                value = null;
            const mapping = this.state.mapping;
            mapping[field] = value;
            this.setState({ mapping: mapping }, this.checkButtonVisbility)
        }

        return (
            <FieldInstance label={Helper.getTranslation(translationKey)} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }



    private renderCheckBox = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.mapping.IsActive;
        props.onChange = (_, value) => {
            const mapping = this.state.mapping;
            mapping.IsActive = value;
            this.setState({ mapping: mapping })
        }

        return (
            <FieldInstance label={Helper.getTranslation("Adresse.Freigegeben")} noHover={true}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    private checkButtonVisbility = () => {
        const showButton = !Helper.isNullOrEmpty(this.state.mapping.ChannelId) && Helper.hasValue(this.state.mapping.GrNr) && !Helper.isNullOrEmpty(this.state.mapping.Locale);
        this.changeButtonState(showButton);
    }

    private changeButtonState = (enabled: boolean) => {
        if (enabled) {
            this.button.removeAttribute('disabled')
        } else {
            this.button.setAttribute('disabled', 'disabled')
        }
    } 

    componentDidMount() {
        this.button = document.querySelector('.k-dialog button.k-button.k-button-solid-primary');
        this.changeButtonState(!this.props.isNew);
    }

    render() {
        return (
            <Dialog {...this.dialogProps}>
                {this.buildDropDown("Einsatz.GrNrFilter", "GrNr", this.props.groups.map((item) => { return { Key: item.GrNr, Value: item.Bezeichnung } }), !this.props.isNew)}
                {this.buildDropDown("MST.UI.Channel", "ChannelId", this.state.channels.map((map => { return { Key: map.id, Value: map.displayName } })), !this.props.isNew)}
                {this.buildDropDown("MST.UI.Locale", "Locale", this.props.localizations, false)}
                {this.renderCheckBox()}
            </Dialog>
        )
    }

}

interface MappingDialogProps {
    groups: Group[];
    localizations: KeyValuePair<string, string>[];
    mapping: GroupChannelMapping;
    onOk: (mapping: GroupChannelMapping) => void;
    onCancel: () => void;
    validate: (mapping: GroupChannelMapping) => boolean;
    title: string;
    isNew: boolean;
}